// Action types
export const gtmEventTypes = {
  COMPARE_TOOL_CHANGE_SELECTION: 'COMPARE_TOOL_CHANGE_SELECTION',
  COMPARE_TOOL_TOGGLE_ACCORDION: 'COMPARE_TOOL_TOGGLE_ACCORDION',
  COMPARE_TOOL_CLICK_CTA: 'COMPARE_TOOL_CLICK_CTA',
  COMPARE_TOOL_CLICK_PRICE_DISCLAIMER: 'COMPARE_TOOL_CLICK_PRICE_DISCLAIMER',
}

export const gtmEvents = {
  [gtmEventTypes.COMPARE_TOOL_CHANGE_SELECTION]: ({eventID, actionMessage}) => ({
    type: gtmEventTypes.CHANGE_SELECTION,
    event: 'reactjs.event',
    eventID,
    pageCategory: 'Compare Tool',
    pageAction: actionMessage,
  }),
  [gtmEventTypes.COMPARE_TOOL_TOGGLE_ACCORDION]: ({eventID, actionMessage}) => ({
    type: gtmEventTypes.TOGGLE_ACCORDION,
    event: 'reactjs.event',
    eventID,
    pageCategory: 'Compare Tool',
    pageAction: actionMessage,
  }),
  [gtmEventTypes.COMPARE_TOOL_CLICK_CTA]: ({eventID, actionMessage}) => ({
    type: gtmEventTypes.CLICK_CTA,
    event: 'reactjs.event',
    eventID,
    pageCategory: 'Compare Tool',
    pageAction: actionMessage,
  }),
  [gtmEventTypes.COMPARE_TOOL_CLICK_PRICE_DISCLAIMER]: ({eventID, actionMessage}) => ({
    type: gtmEventTypes.CLICK_PRICE_DISCLAIMER,
    event: 'reactjs.event',
    eventID,
    pageCategory: 'Compare Tool',
    pageAction: actionMessage,
  }),
}



// WEBPACK FOOTER //
// ./src/store/gtm-events/compare-tool-duck.js